export const PIPELINE_COLUMNS_DROPPABLE_ID = "pipeline-columns";

export const PIPELINE_COLUMN_DND_TYPE = "PIPELINE_COLUMN";

export const PIPELINE_CARD_DND_TYPE = "PIPELINE_CARD";

const COLUMN_DRAGGABLE_PREFIX = "stage-";
const CARD_DRAGGABLE_PREFIX = "lead-";

export const columnDraggableId = (stageId: number | string): string =>
  `${COLUMN_DRAGGABLE_PREFIX}${stageId}`;

export const cardDraggableId = (leadId: number | string): string =>
  `${CARD_DRAGGABLE_PREFIX}${leadId}`;

export const leadIdFromCardDraggableId = (draggableId: string): number =>
  Number(draggableId.slice(CARD_DRAGGABLE_PREFIX.length));
